import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, setMuted, SFX } from "@/lib/sounds";

export default function SoundToggle() {
  const [muted, setMutedState] = useState(isMuted());

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    setMutedState(next);
    if (!next) SFX.notify();
  };

  return (
    <button
      data-testid="sound-toggle"
      onClick={toggle}
      className="text-[#8c8c8c] hover:text-[#E55A00] shrink-0"
      aria-label={muted ? "Unmute" : "Mute"}
    >
      {muted
        ? <VolumeX className="w-4 h-4" strokeWidth={1.5} />
        : <Volume2 className="w-4 h-4" strokeWidth={1.5} />}
    </button>
  );
}
